/**
 * Macaron AOV flow (2026-10-05), C3: PDP "second chance" prompt.
 *
 * Mirrors DrawerMacaronOffer (assets/drawer-value-boost.js) but for the
 * product page itself -- shown below/beside the builder once the cart
 * already holds exactly one box of this product, hidden otherwise (so a
 * first-time visitor who hasn't added anything yet sees nothing, per spec).
 * Deliberately NOT shared code with the drawer module: this runs on every
 * product page load (not inside the cart drawer's own re-render cycle), so
 * it only needs a single /cart.js check on load plus the same two cart-add
 * actions, tagged _pb_src=macaron_same_pdp / macaron_new_pdp to keep PDP
 * attach-rate reporting separate from the drawer's.
 */
(function () {
  function money(amountCents) {
    return (amountCents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function fillTemplate(template, values) {
    return (template || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function addQueryParam(url, key, value) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + key + '=' + encodeURIComponent(value);
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // Reuse the theme's own toggle rather than re-deriving its open-cart/
    // active-class/dispatch sequence (assets/app.js CartDrawer connectedCallback).
    document.getElementById('cart-drawer-toggle')?.click();
  }

  function init() {
    var el = document.querySelector('[data-second-chance]');
    if (!el) return;

    // Arrived here via "Skomponuj drugie pudełko" (from the drawer or a prior
    // visit) -- the customer is already in the middle of composing box #2 on
    // this exact page, so a second "second chance" prompt would be redundant/
    // confusing. Checked once against the page's own load-time URL, not
    // re-checked after box-builder.js clears the param post-submit.
    var pbSrc = new URLSearchParams(window.location.search).get('pb_src') || '';
    if (pbSrc.indexOf('macaron_new') === 0) return;

    var productId = parseInt(el.dataset.productId, 10);
    var flavorsKey = el.dataset.flavorsKey;

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var lines = cart.items.filter(function (item) { return item.product_id === productId; });
      var qty = lines.reduce(function (sum, l) { return sum + l.quantity; }, 0);
      if (qty !== 1) return; // stays hidden: 0 boxes (nothing added yet) or 2+ (prompt is moot)

      var line = lines[0];
      var flavorsValue = (line.properties && line.properties[flavorsKey]) || '';
      var newBoxUrl = addQueryParam(window.location.pathname, 'pb_src', 'macaron_new_pdp') + (el.dataset.builderAnchor || '');

      // "Compose new" first/primary, "same box" second/secondary (2026-10-05
      // revision) -- see drawer-value-boost.js's DrawerMacaronOffer for the
      // same change and why (3/3 two-box orders so far picked different
      // flavours each time).
      el.innerHTML =
        '<a class="box-builder__second-chance-button box-builder__second-chance-button--new box-builder__second-chance-button--primary" href="' + newBoxUrl + '">' +
        (el.dataset.newButton || '') +
        '</a>' +
        '<button type="button" class="box-builder__second-chance-button box-builder__second-chance-button--same box-builder__second-chance-button--secondary" data-variant-id="' + line.variant_id + '">' +
        fillTemplate(el.dataset.sameButton, { price: money(line.price) }) +
        '</button>' +
        '<p class="box-builder__second-chance-error" hidden></p>';
      el.hidden = false;

      var errorEl = el.querySelector('.box-builder__second-chance-error');
      var sameBtn = el.querySelector('.box-builder__second-chance-button--same');
      sameBtn.addEventListener('click', function () {
        sameBtn.disabled = true;
        errorEl.hidden = true;
        var props = {};
        if (flavorsValue) props[flavorsKey] = flavorsValue;
        props['_pb_src'] = 'macaron_same_pdp';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: line.variant_id, quantity: 1, properties: props }] }),
        }).then(function (res) {
          if (!res.ok) throw new Error('macaron add failed');
          openCartDrawer();
        }).catch(function () {
          sameBtn.disabled = false;
          errorEl.textContent = el.dataset.error || '';
          errorEl.hidden = false;
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
